import React from 'react';

const PACKAGE_STATUS_LABELS = {
  in_warehouse: 'En almacén',
  in_fastmax: 'En FastMax',
  with_driver: 'Con conductor',
  out_for_delivery: 'En reparto',
  delivered: 'Entregado',
  returned: 'Devuelto',
  lost_or_damaged: 'Perdido o dañado',
  postponed_with_driver: 'Postergado con conductor',
};

export function ScanResult({ result }) {
  const { route_zone_name: zone, delivery_type: type, driver_id: driverId } = result;
  const deliveryDate = result.delivery_date?.slice(0, 10);
  const missingZone = type === 'lima' && !zone;
  const shouldSortToZone = !driverId && result.package_status === 'in_fastmax';

  return (
    <div className="w-full space-y-3 font-montserrat" role="status">
      {zone ? (
        <div className="rounded-xl border-2 border-brand-primary bg-brand-primary/10 px-4 py-3 text-center">
          <p className="text-xs font-semibold uppercase tracking-wide text-gray-600">Zona / cajón</p>
          <p className="text-2xl font-extrabold text-brand-primary">{zone}</p>
          {shouldSortToZone && <p className="text-sm font-semibold text-gray-700">Colocar en cajón de esta zona</p>}
        </div>
      ) : (
        <div className="rounded-xl border-2 border-amber-500 bg-amber-50 px-4 py-3 text-center text-amber-900">
          <p className="font-bold">Revisión manual: no colocar en un cajón de zona</p>
          <p className="text-sm">
            {missingZone ? 'Esta entrega de Lima no tiene zona vinculada.' :
              type === 'provincia' ? 'La entrega de provincia no tiene zona de Lima.' :
                'El paquete no tiene un DeliveryPoint vinculado.'}
          </p>
        </div>
      )}
      <div className="space-y-1 text-sm text-gray-700">
        <p><span className="font-semibold">Paquete:</span> {result.tracking_code}</p>
        <p><span className="font-semibold">Distrito:</span> {result.district || 'No definido'}</p>
        <p><span className="font-semibold">Conductor ID:</span> {driverId || 'Sin asignar'}</p>
        <p><span className="font-semibold">Estado de entrega:</span> {result.delivery_status || 'No definido'}</p>
        <p><span className="font-semibold">Fecha de entrega:</span> {deliveryDate ? deliveryDate.split('-').reverse().join('/') : 'No definida'}</p>
        <p><span className="font-semibold">Estado del paquete:</span> {PACKAGE_STATUS_LABELS[result.package_status] || result.package_status}</p>
        <p className="font-semibold">
          {result.status_changed
            ? 'Paquete registrado en Fast Max'
            : 'El paquete ya estaba en Fast Max; escaneo registrado'}
        </p>
      </div>
    </div>
  );
}
